/*eslint-disable*/
import MarketingBlacklistCookies from '../constants/MarketingBlacklistCookies';

export default function gtmInit() {
    window.dataLayer = [];
    const blackListContent = ['ua', 'customScripts','customPixels', 'bzi', 'awct', 'gclidw'];

    if (document.cookie.indexOf('GOOGLE_ANALYTICS') > -1) {
        const index = blackListContent.indexOf('ua');
        if (index > -1) {
            blackListContent.splice(index, 1);
        }
    }

    if (document.cookie.indexOf('FACEBOOK_PIXEL') > -1
    // Those 3 cookies are part of the Marketing Group. They are either all accepted, either all refused, therefore, for perfomance reasons, we shall execute the code checking the presence of the cookie only once.
    // && document.cookie.indexOf('GOOGLE_ADS') > -1
    // && document.cookie.indexOf('LINKEDIN') > -1
    ){
        MarketingBlacklistCookies.forEach(item => {
            const index = blackListContent.indexOf(item);
            if (index > -1) {
                blackListContent.splice(index, 1);
            }
        });
    }

    window.dataLayer.push({'gtm.blacklist': blackListContent});

    (function(w,d,s,l,i){
        if (document.cookie.indexOf('FACEBOOK_PIXEL') === -1
        && document.cookie.indexOf('GOOGLE_ANALYTICS') === -1) {
            return;
        }
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),
            dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',env.GTM_KEY);
}